import { render } from "./LedgersMenuView.vue?vue&type=template&id=39cfab16&scoped=true"
import script from "./LedgersMenuView.vue?vue&type=script&lang=js"
export * from "./LedgersMenuView.vue?vue&type=script&lang=js"

import "./LedgersMenuView.vue?vue&type=style&index=0&id=39cfab16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39cfab16"]])

export default __exports__